import { render, staticRenderFns } from "./alloy.vue?vue&type=template&id=3260ac6e&scoped=true"
import script from "./alloy.vue?vue&type=script&lang=js"
export * from "./alloy.vue?vue&type=script&lang=js"
import style0 from "./alloy.vue?vue&type=style&index=0&id=3260ac6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3260ac6e",
  null
  
)

export default component.exports